window.addEventListener('load', () => {
    const panel = document.getElementById('buildZoneHeader');
    if (panel) {
        let map;
        let featureLayer;
        let buildZones;
        const auCenter = {lat: -23.375068, lng: 132.731304};
        const startZoom = 4;

        const initBuildZones = () => {
            const buildZonesTemplate = panel.querySelector("template[data-build-zones]");
            const buildZonesString = buildZonesTemplate.getAttribute("data-build-zones");
            buildZones = JSON.parse(buildZonesString);
        };

        const markAllBuildZones = () => {
            const includedBuildZones = [];
            buildZones.forEach((zone) => {
                if (zone.validBuildZone) {
                    includedBuildZones.push(zone);
                }
            });
            findBoundary(includedBuildZones);
        };

        const initMap = async () => {
            // Request needed libraries.
            const { Map } = await google.maps.importLibrary("maps");

            const mapDiv= panel.querySelector("[data-build-zone-map]");

            map = new Map(mapDiv, {
                zoom: startZoom,
                center: auCenter,
                mapId: mapDiv.getAttribute("data-map-id"),
                streetViewControl: false,
                fullscreenControl: false,
                mapTypeControl: false,
                zoomControl: true,
                scrollwheel: false,
                disableDefaultUI: true,
            });

            featureLayer = map.getFeatureLayer("LOCALITY");
        };

        const markBuildZone = () => {
            const searchField = panel.querySelector("input[name='query']");
            const postCodeString = searchField?.value;
            if (!postCodeString) {
                return;
            }
            const postCode = parseInt(postCodeString);
            const includedBuildZones = [];
            buildZones.forEach((zone) => {
                if ((zone.postCode === postCode) && zone.validBuildZone) {
                    includedBuildZones.push(zone);
                }
            });
            findBoundary(includedBuildZones);
        };

        const findBoundary = async (includedBuildZones) => {
            const { LatLngBounds } = await google.maps.importLibrary("core")

            var bounds = new LatLngBounds();

            const totalPlaces = includedBuildZones.length;
            const placeIds = [];

            if (totalPlaces) {
                for (let buildZone of includedBuildZones) {
                    let mapDetails = buildZone.mapDetails;
                    for (let place of mapDetails) {
                        placeIds.push(place.placeId);
                        for (let boundary of place.mapBoundaries) {
                            try {
                                bounds.extend({
                                    lat: parseFloat(boundary.lat),
                                    lng: parseFloat(boundary.lng)
                                });
                            } catch ( e ) {
                                console.log("ERROR with boundary for buildZone: " + buildZone.suburb, boundary);
                            }
                        }
                    }
                }
            }

            if (placeIds.length) {
                styleBoundary(placeIds);
                map.fitBounds(bounds, 0);
            } else {
                markAllBuildZones();
            }
        };

        const styleBoundary = (placeIds) => {
            const styleFill = {
                strokeColor: "#CCBB9A",
                strokeOpacity: 1,
                strokeWeight: 2,
                fillColor: "#99774B",
                fillOpacity: 0.1,
            };

            featureLayer.style = (params) => {
                if (placeIds.includes(params.feature.placeId)) {
                    return styleFill;
                }
            };
        };

        const initializeSearchField = () => {
            const searchField = panel.querySelector("input[name='query']");
            const debounceHandler = debounce(() => {markBuildZone();}, 1000);
            searchField?.addEventListener('input', debounceHandler);
        };

        const debounce = (callback, waitTime) => {
            let timer;
            return (...args) => {
                clearTimeout(timer);
                timer = setTimeout(() => {
                    callback(...args);
                }, waitTime);
            };
        }

        const resetMap = () => {
            featureLayer.style = null;
            map.setZoom(startZoom);
            map.setCenter(auCenter);
        };

        /**
         * MAIN
         */
        initBuildZones();
        initMap();
        initializeSearchField();
        markAllBuildZones();
    }
});